import { Controller } from '@hotwired/stimulus'

// Toggles a button into a disabled "loading" state with a spinner, used to
// preview the new primary button's async/submitting state.
export default class extends Controller {
  static targets = ['spinner', 'label']
  static values = { duration: { type: Number, default: 1600 } }

  start() {
    if (this.element.disabled) return

    this.element.disabled = true
    this.element.classList.add('cursor-wait')
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove('hidden')

    this.timeout = setTimeout(() => {
      this.element.disabled = false
      this.element.classList.remove('cursor-wait')
      if (this.hasSpinnerTarget) this.spinnerTarget.classList.add('hidden')
    }, this.durationValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
